import {Component, HostListener, OnInit} from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { Router, NavigationEnd } from '@angular/router';
import {CommonUtil} from '../utils/common.util';
import {ConstantUtils} from '../utils/constant.utils';

@Component({
  selector: 'app-pages',
  template: `
    <div class='al-content {{className}}'>
      <router-outlet></router-outlet>
    </div>
  `
})
export class PagesComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();

  className = 'parent-wrapper';
  constructor(private router: Router) {
    // setting school ID temporary
    const data = {
      SCHOOL_ID: 'cluni_hr_sec_school'
    };
    localStorage.setItem('bootStrapData', JSON.stringify(data));
    // , '/staff/login'
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentPath = event.url;

        console.log('Current Path ', currentPath);
        if (currentPath.startsWith('/enquiry')) {
          localStorage.setItem(ConstantUtils.SOURCE_FROM, ConstantUtils.ENQUIRY);
        } else {
          localStorage.setItem(ConstantUtils.SOURCE_FROM, ConstantUtils.ADMIN);
        }
        const ignoredUrls = ['/admin/login', '/super-admin/login', '/staff/email-login', '/enquiry/login', '/session-expired', '/unauthorized-access','/privacy-policy', '/landing'];
        if (ignoredUrls.indexOf(currentPath) < 0) {
          const token = localStorage.getItem('userToken');
          if (token === null) {
            this.router.navigate(['unauthorized-access']);
          }
          const userToken = jwt_decode(token);
          const userTypesArr = ['admin', 'staff', 'superAdmin'];
          const bootData = (localStorage.getItem('bootStrapData')) ? JSON.parse(localStorage.getItem('bootStrapData')) : false;
          const schoolId = (bootData) ? bootData.SCHOOL_ID : false;
          const userData = userToken.hasOwnProperty(schoolId) ? userToken[schoolId] : '';
          if (userData.hasOwnProperty('user_type') && userData.user_type !== '' && userTypesArr.indexOf(userData.user_type) !== -1) {
            const userType = userData.user_type.replace(/[\w]([A-Z])/g, function (m) {
              return m[0] + '-' + m[1];
            }).toLowerCase();

            const validPath = currentPath.startsWith('/' + userType);

            if (!validPath && !currentPath.startsWith('/enquiry')) {
              if (currentPath.startsWith('/enquiry')){
                localStorage.setItem(ConstantUtils.SOURCE_FROM, ConstantUtils.ENQUIRY);
              } else {
                localStorage.setItem(ConstantUtils.SOURCE_FROM, ConstantUtils.ADMIN);
              }
              this.router.navigate(['unauthorized-access']);
            }
          } else {
            this.router.navigate(['unauthorized-access']);
          }
        }
      }
    });
  }

  ngOnInit() {
    // icon btn tooltip
    (<any>$(function () {
      (<any>$('[data-toggle="tooltip"]')).tooltip();
    }));

  }
}
